<script setup lang="ts">
defineProps({
  modelValue: {
    type: [String, Number, null],
    default: undefined
  },
  label: String,
  options: {
    type: Array as () => { value: string | number; label: string }[],
    required: true
  },
  placeholder: String,
  error: String,
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div>
    <label v-if="label" class="block mb-2 text-subtext">{{ label }}</label>
    <select
      :value="modelValue"
      @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
      :disabled="disabled"
      class="design"
      :class="{ 'opacity-50 cursor-not-allowed': disabled }"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <div class="pt-1 pb-1 text-red-500" v-if="error">{{ error }}</div>
  </div>
</template>

<style scoped>
.design {
  @apply bg-metal-800 border border-metal-700 hover:border-metal-600 focus:outline-none text-metal-300 rounded focus:ring-metal-700 focus:border-metal-500 block w-full px-2 py-1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1rem;
  padding-right: 2rem;
}
</style>
